var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandsRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.068,
    height: 118.004,
    viewBox: "0 0 100.068 118.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8353",
    "data-name": "Group 8353",
    transform: "translate(550.975 -75.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160953",
    "data-name": "Path 160953",
    d: "M-473.5,262.95l.958,1.055-16.387,16.384-18.233-18.26,16.379-16.348.9.74c.424-1.131.823-2.171,1.205-3.217q5.151-14.108,10.278-28.225a8.318,8.318,0,0,0,.479-2.7c.045-5.272.02-10.545.027-15.818a4.272,4.272,0,0,1,2.572-4.149,4.207,4.207,0,0,1,4.63.56A4.728,4.728,0,0,1-468.977,197q-.007,18.286,0,36.572c0,6.327-.087,12.656.02,18.982C-468.883,256.734-470.019,260.28-473.5,262.95Zm2.955-44.862a6.467,6.467,0,0,0-5.694,5.194c-.152.828-.2,1.678-.38,2.5-1.018,4.573-2.063,9.14-3.095,13.69h-1.936c.539-1.843,1.006-3.481,1.5-5.111a17.938,17.938,0,0,0,.615-1.763c.577-3.061,1.113-6.131,1.653-9.2a8.055,8.055,0,0,1,6.4-6.846c.828-.212.972-.532.967-1.263-.03-4.133-.006-8.267-.035-12.4a2.891,2.891,0,0,0-2.91-3.136c-1.749-.006-2.846,1.172-2.861,3.128-.019,2.531.061,5.064-.031,7.591a16.9,16.9,0,0,1-.585,4.959c-3.7,10.435-7.519,20.826-11.343,31.215a1.558,1.558,0,0,0,.435,1.951c3.611,3.546,7.177,7.139,10.751,10.722.825.826,1.627,1.676,2.458,2.535a9.408,9.408,0,0,0,4.1-8.015q0-17.272-.011-34.544C-470.542,218.92-470.541,218.545-470.541,218.088Zm.019-18.963c-.095-2.012.49-3.945-1.432-5.157a2.661,2.661,0,0,0-3.2.12c-1.752,1.292-1.081,3.136-1.21,5.006A4.864,4.864,0,0,1-470.522,199.125Z",
    transform: "translate(-32.724 -87.149)",
    fill: "#752f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160954",
    "data-name": "Path 160954",
    d: "M-330.109,280.46-346.5,264.055l.916-1.072c-3.475-2.666-4.534-6.259-4.516-10.481.077-18.478.032-36.957.034-55.435,0-2.365,1.026-4.044,2.872-4.746a4.4,4.4,0,0,1,6.012,4.259c.055,5.273.005,10.547.044,15.82a7.524,7.524,0,0,0,.4,2.459c3.8,10.524,7.644,21.035,11.522,31.678l.932-.719,16.4,16.421Zm-14.357-18.606c4.479-4.477,8.847-8.878,13.269-13.226a1.561,1.561,0,0,0,.413-1.951q-5.811-15.833-11.553-31.692a6.086,6.086,0,0,1-.354-1.966c-.041-3.375.036-6.753-.082-10.124a4.181,4.181,0,0,0-1.017-2.431,2.493,2.493,0,0,0-3.049-.4,2.93,2.93,0,0,0-1.683,2.884q-.01,6.455-.006,12.911a2.531,2.531,0,0,0,.084.465,2.922,2.922,0,0,0,.391.154,8.2,8.2,0,0,1,6.912,7.226c.234,1.413.393,2.842.712,4.236.532,2.322,1.168,4.62,1.754,6.929.385,1.516.759,3.034,1.172,4.687h-1.51c-.547-1.72-1.05-3.314-1.562-4.906a11.74,11.74,0,0,1-.481-1.412q-.889-4.847-1.724-9.7c-.5-2.947-3.093-5.4-5.662-5.319a.906.906,0,0,0-.069.24c-.006,12.025-.05,24.05.018,36.074A8.831,8.831,0,0,0-344.466,261.855Zm1.747-62.751c0-1.05.038-1.89-.008-2.726a2.865,2.865,0,0,0-2.824-2.818,2.94,2.94,0,0,0-2.957,2.721c-.079.9-.014,1.812-.014,2.885A4.871,4.871,0,0,1-342.718,199.1Z",
    transform: "translate(-150.019 -87.19)",
    fill: "#752f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160955",
    "data-name": "Path 160955",
    d: "M-454.823,100.89l1.432-.852,11.708,20.273-1.444.831Z",
    transform: "translate(-71.811 -18.5)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160956",
    "data-name": "Path 160956",
    d: "M-504.9,182.939l-.834,1.434-20.269-11.7.857-1.426Z",
    transform: "translate(-18.647 -71.682)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160957",
    "data-name": "Path 160957",
    d: "M-263.634,324.068l.8-1.455,20.262,11.695-.815,1.45Z",
    transform: "translate(-214.599 -184.729)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160958",
    "data-name": "Path 160958",
    d: "M-301.971,121.174l-1.454-.815,11.695-20.265,1.44.834Z",
    transform: "translate(-184.881 -18.541)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160959",
    "data-name": "Path 160959",
    d: "M-505.729,322.608l.808,1.453-20.226,11.68-.863-1.419Z",
    transform: "translate(-18.645 -184.725)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160960",
    "data-name": "Path 160960",
    d: "M-262.825,184.393l-.815-1.454,20.231-11.674.862,1.414Z",
    transform: "translate(-214.595 -71.696)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160961",
    "data-name": "Path 160961",
    d: "M-355.909,75.267h1.415V98.633l-1.415.071Z",
    transform: "translate(-145.684 0)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160962",
    "data-name": "Path 160962",
    d: "M-550.912,271.559c-.02-.436-.039-.843-.063-1.367h23.408v1.367Z",
    transform: "translate(0 -145.578)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160963",
    "data-name": "Path 160963",
    d: "M-247.82,271.481v-1.437H-224.5v1.437Z",
    transform: "translate(-226.41 -145.468)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160964",
    "data-name": "Path 160964",
    d: "M-395.509,126.217l1.587-.443,3.037,11.273-1.59.474Z",
    transform: "translate(-116.109 -37.721)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160965",
    "data-name": "Path 160965",
    d: "M-327.5,137.585l-1.6-.453,3.018-11.254,1.6.411Z",
    transform: "translate(-165.708 -37.799)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160966",
    "data-name": "Path 160966",
    d: "M-499.785,301.557l-.414-1.6,11.275-3.034.434,1.6Z",
    transform: "translate(-37.922 -165.545)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160967",
    "data-name": "Path 160967",
    d: "M-240.605,299.98l-.474,1.584-11.243-3.009.408-1.6Z",
    transform: "translate(-223.047 -165.563)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160968",
    "data-name": "Path 160968",
    d: "M-500.2,232.146l.419-1.59,11.3,3.021-.45,1.6Z",
    transform: "translate(-37.919 -115.977)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160969",
    "data-name": "Path 160969",
    d: "M-241.173,230.535l.434,1.59L-252,235.159l-.474-1.59Z",
    transform: "translate(-222.932 -115.961)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160970",
    "data-name": "Path 160970",
    d: "M-462.176,165.25l.965-.749,8.2,8.282-.909.78Z",
    transform: "translate(-66.319 -66.644)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160971",
    "data-name": "Path 160971",
    d: "M-279.768,173.209l-.765-.914,8.255-8.188.842.8Z",
    transform: "translate(-201.978 -66.35)",
    fill: "#f26522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160972",
    "data-name": "Path 160972",
    d: "M-415.335,241.086c0,.457,0,.832,0,1.207q.006,17.272.011,34.544a9.408,9.408,0,0,1-4.1,8.015c-.832-.859-1.634-1.709-2.458-2.535-3.575-3.583-7.14-7.176-10.751-10.722a1.558,1.558,0,0,1-.435-1.951c3.824-10.39,7.647-20.78,11.343-31.215a16.9,16.9,0,0,0,.585-4.959c.092-2.527.011-5.061.031-7.591.015-1.956,1.112-3.134,2.861-3.128a2.891,2.891,0,0,1,2.91,3.136c.029,4.133.005,8.267.035,12.4.005.732-.139,1.051-.967,1.264a8.055,8.055,0,0,0-6.4,6.846c-.541,3.068-1.076,6.137-1.653,9.2a17.906,17.906,0,0,1-.615,1.763c-.492,1.63-.96,3.268-1.5,5.111h1.936c1.032-4.55,2.077-9.117,3.095-13.69.183-.82.228-1.67.381-2.5A6.467,6.467,0,0,1-415.335,241.086Z",
    transform: "translate(-87.931 -110.147)",
    fill: "#fcf1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160973",
    "data-name": "Path 160973",
    d: "M-379.731,203.657a4.864,4.864,0,0,0-5.837-.031c.129-1.87-.542-3.714,1.21-5.006a2.661,2.661,0,0,1,3.2-.12C-379.241,199.712-379.826,201.645-379.731,203.657Z",
    transform: "translate(-123.516 -91.681)",
    fill: "#fcf1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160974",
    "data-name": "Path 160974",
    d: "M-339.825,284.638a8.831,8.831,0,0,1-4.028-7.321c-.068-12.024-.024-24.049-.018-36.074a.877.877,0,0,1,.07-.24c2.569-.082,5.158,2.371,5.662,5.319q.83,4.857,1.724,9.7a11.71,11.71,0,0,0,.481,1.412c.512,1.592,1.015,3.186,1.562,4.906h1.51c-.413-1.653-.788-3.172-1.172-4.687-.586-2.31-1.222-4.607-1.754-6.929-.319-1.393-.478-2.823-.712-4.236a8.2,8.2,0,0,0-6.912-7.226,2.921,2.921,0,0,1-.391-.154,2.528,2.528,0,0,1-.084-.465q0-6.456.006-12.911a2.93,2.93,0,0,1,1.683-2.884,2.493,2.493,0,0,1,3.049.4,4.181,4.181,0,0,1,1.017,2.431c.118,3.371.041,6.749.082,10.124a6.087,6.087,0,0,0,.354,1.966q5.747,15.857,11.554,31.692a1.561,1.561,0,0,1-.413,1.951C-330.978,275.76-335.346,280.161-339.825,284.638Z",
    transform: "translate(-154.66 -109.973)",
    fill: "#fcf1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160975",
    "data-name": "Path 160975",
    d: "M-338.124,203.671a4.871,4.871,0,0,0-5.8.063c0-1.073-.065-1.985.014-2.885a2.94,2.94,0,0,1,2.957-2.721,2.865,2.865,0,0,1,2.824,2.818C-338.086,201.781-338.124,202.621-338.124,203.671Z",
    transform: "translate(-154.614 -91.757)",
    fill: "#fcf1df"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsRed);
export default __webpack_public_path__ + "static/media/hands-red.9ee3e5a09a186167ab4c198f18a3dac6.svg";
export { ForwardRef as ReactComponent };